export const LEAD_MSG_STATUS_PENDING = 'pending';
export const LEAD_MSG_STATUS_SENT = 'sent';
export const LEAD_MSG_STATUS_DELIVERED = 'delivered';
export const LEAD_MSG_STATUS_READ = 'read';
export const LEAD_MSG_STATUS_DELETED = 'deleted';
export const LEAD_MSG_STATUS_ERROR = 'error';

export const getLeadMessageStatusColor = (status: string | null): string => {
  switch (status) {
    case LEAD_MSG_STATUS_READ:
      return 'rgb(22, 119, 255)';
    case LEAD_MSG_STATUS_DELETED:
    case LEAD_MSG_STATUS_ERROR:
      return 'rgb(225, 79, 79)';
    default:
      return 'rgba(0, 0, 0, 0.45)';
  }
};
